import { Component, HostListener, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { AppState } from "src/app/store/app.reducer";
import * as DeviceVctActions from 'src/app/store/device-vct/device-vct.actions';
import { StandardPageLayout, StandardNewValidator } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";
import { FeatureVct, ModuleVct } from "src/app/model/device-vct/device-vct-implant";
import { DEVICE_VCT_PANEL_FEATURES_EDIT_LIST } from "src/app/conf/devices-vct";

@Component({
	templateUrl: './edit-operators-vct.dialog.component.html',
})

export class EditOperatorsVctDialogComponent implements OnInit {
	editDeviceForm: FormGroup;

	module: ModuleVct;

	featureListShow: FeatureVct[];

	somethingIsSaved: boolean = false;

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private dialogRef: DynamicDialogRef,
		public config: DynamicDialogConfig,
		private formBuilder: FormBuilder,
	) {

		if (config.data !== undefined && this.config.data.module !== undefined) {
			this.module = this.config.data.module;
		} else {
			this.module = undefined;
		}
		this.initSelectors();
	}

	initSelectors(): void {
	}

	ngOnInit(): void {
		this.buildForm();
		this.onResize();

		StandardNewValidator.setFirstCompile(true);
	}


	buildForm(): void {
		this.editDeviceForm = this.formBuilder.group(this.buildFormBuilder());
	}


	buildFormBuilder() {
		this.featureListShow = [];
		const res = {};
		let name = this.module.Name;
		if (this.module.AliasName !== '') {
			name = this.module.AliasName;
		}
		res['name'] = [name, [Validators.required,]];
		if (this.module.Features !== undefined && this.module.Features.length > 0) {
			this.module.Features.forEach((fea) => {
				if (DEVICE_VCT_PANEL_FEATURES_EDIT_LIST.includes(fea.FeatureId)) {
					let name = fea.Name;
					if (fea.AliasName !== '') {
						name = fea.AliasName;
					}
					res[fea.Id] = [name, [Validators.required]];
					this.featureListShow.push(fea);
					this.featureListShow = this.featureListShow.sort((a, b) => { return a.FeatureId < b.FeatureId ? -1 : 1 });

				}
			});
		}
		return res;
	}

	translate(txt: string): string {
		return txt.toUpperCase().replace(' ', '');
	}


	get f(): any {
		return this.editDeviceForm.controls;
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.editDeviceForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.editDeviceForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	saveFea(fea: FeatureVct): void {
		const newName = this.f[fea.Id].value;
		if (fea.AliasName !== newName) {
			this.store.dispatch(DeviceVctActions.editVctFeatureName({ featureId: fea.Id, aliasName: newName }));
			this.f[fea.Id].markAsPristine(); // we need for disable check save active after save
			this.somethingIsSaved = true;
		}
	}

	saveName(): void {
		const newName = this.f.name.value;
		if (this.module.AliasName !== newName) {
			this.store.dispatch(DeviceVctActions.editVctModuleName({ moduleId: this.module.Id, aliasName: newName }));
			this.f.name.markAsPristine(); // we need for disable check save active after save
			this.somethingIsSaved = true;
		}
	}

	closeDialog(): void {
		this.dialogRef.close(this.somethingIsSaved);
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			// this.save();
		}
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-30rem');
	}

	newShowErrors(type: EditOperatorsVctDialogComponent['f'], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: EditOperatorsVctDialogComponent['f']): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}
}